import { FunctionComponent, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react-lite";

import { Tooltip } from "primereact/tooltip";

import { TooltipWrapper } from "../../../../../components/Shared/Components/TooltipWrapper/TooltipWrapper";
import { ShowTooltipWhenTextTruncated } from "../../../../../components/Shared/ShowTooltipWhenTruncated/ShowTooltipWhenTruncated";
import { translationKeys } from "../../../../../models/app-translation-keys";
import { ICustomKnowledgeBaseReadChatbot } from "../../../../../stores";
import { KnowledgeBaseTypeIcon } from "../KnowledgeBaseTypeIcon/KnowledgeBaseTypeIcon";

import "./KnowledgeBaseDropdownValue.scss";

interface IKnowledgeBaseDropdownValueProps {
  item: ICustomKnowledgeBaseReadChatbot;
  translatedKnowledgeBaseName: (knowledgeBase: ICustomKnowledgeBaseReadChatbot) => string;
}

const RawKnowledgeBaseDropdownValue: FunctionComponent<IKnowledgeBaseDropdownValueProps> = (
  props: IKnowledgeBaseDropdownValueProps,
) => {
  const { t } = useTranslation();
  const knowledgeBaseValueRef = useRef<HTMLDivElement>(null);
  const tooltipRef = useRef<Tooltip>(null);
  const [typeIconTooltipVisible, setTypeIconTooltipVisible] = useState<boolean>(false);

  useEffect(() => {
    if (typeIconTooltipVisible && tooltipRef?.current?.props.disabled) {
      tooltipRef.current?.hide();
    }
  }, [typeIconTooltipVisible]);

  return (
    <div className="knowledge-base-dropdown-value" ref={knowledgeBaseValueRef}>
      <TooltipWrapper
        targetRef={knowledgeBaseValueRef}
        tooltipRef={tooltipRef}
        content={t(translationKeys.feature.chatbot.knowledgebases.dropdownTooltip)}
        position="right"
        disabled={typeIconTooltipVisible || true}
      />

      <span className="dropdown-tooltip-item">
        <ShowTooltipWhenTextTruncated
          tooltipContent={props.translatedKnowledgeBaseName(props.item)}
          tooltipPosition="bottom"
        >
          {props.translatedKnowledgeBaseName(props.item)}
        </ShowTooltipWhenTextTruncated>
      </span>

      {!!props.item.id && (
        <KnowledgeBaseTypeIcon
          isSpoKnowledgebase={props.item.isSpoKnowledgeBase}
          setIsTooltipVisible={setTypeIconTooltipVisible}
          isActive={false}
        />
      )}
    </div>
  );
};

export const KnowledgeBaseDropdownValue = observer(RawKnowledgeBaseDropdownValue);
